import {TextSearchFilterComponent} from './text-search-filter/text-search-filter.component';
import {JobDepartment} from '../../api/models/job-department';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CacheDataService} from '../../api/services/cache-data.service';
import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, forwardRef, Input, NgZone, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {CdkVirtualScrollViewport} from '@angular/cdk/scrolling';

@Component({
  selector: 'job-department-search',
  templateUrl: './text-search-filter/text-search-filter.component.html',
  styleUrls: ['./text-search-filter/text-search-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => JobDepartmentSearchComponent),
      multi: true
    }
  ]
})
export class JobDepartmentSearchComponent extends TextSearchFilterComponent<JobDepartment> implements ControlValueAccessor, OnInit, AfterViewInit
{
  @ViewChild('scrollDiv') scrollDiv : ElementRef;
  @Input() dataChanged: () => void = () => {};
  @Input() fixedHeight?: number;

  @Output() dataLoadComplete = new EventEmitter<void>();

  constructor(cacheDataService: CacheDataService, ngZone: NgZone) {
    super(cacheDataService, ngZone);
  }

  protected dataUpdated() {
    this.dataChanged();
  }

  protected getHeightValue() : number | undefined {
    if (this.fixedHeight) {
      return this.fixedHeight;
    }
    return undefined;
  }

  ngOnInit() {
    this.callNgOnInit();
  }

  ngAfterViewInit() {
    this.callNgAfterViewInit();
  }

  protected getDivScroller(): ElementRef {
    return this.scrollDiv;
  }

  protected isSelected(target: JobDepartment) : boolean {
    const exists = this._value && this._value.selectedValues && this._value.selectedValues.find(x => x.departmentId === target.departmentId);
    return !!exists;

  }

  protected getDisplay(target: JobDepartment): string {
    return target.department;
  }

  protected async newSearch() {
    this.reloading = true;

    const result = await this.cacheDataService.cacheDataSearchJobDepartments({pageNumber: 1, pageSize: 100, search: this._value?.searchTerms ?? []}).toPromise();

    this.currentPage = 1;
    this.totalPages = result.totalPages;
    this.sourceValues = result.page;

    this.reloading = false;
    this.dataLoadComplete.emit();
  }

  protected async getNextBatch() {
    if (this.currentPage < this.totalPages) {
      this.loading = true;
      this.currentPage++;

      const result = await this.cacheDataService.cacheDataSearchJobDepartments({pageNumber: this.currentPage, pageSize: 100, search: this._value?.searchTerms ?? []}).toPromise();

      this.totalPages = result.totalPages;
      this.loading = false;
      this.sourceValues = [...this.sourceValues, ...result.page];
      this.dataLoadComplete.emit();
    }
  }

  protected getSearchPlaceholder(): string {
    return 'Search Departments...';
  }
}
